import React from "react";
import {Radar} from "react-chartjs-2";

export default function RadarChart({ chartData }) {
  return (
    <>
      <Radar
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: true
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (context.dataset.data) {
                    label += ` ${new Intl.NumberFormat('sr-RS', {
                      style: 'currency',
                      currency: 'RSD'
                    }).format(context.dataset.data[context.dataIndex] ?? 0)}`;
                  }
                  return label;
                }
              }
            }
          }
        }}
      />
    </>
  );
}
